


















import Vue from "vue";
import { Component } from "vue-property-decorator";
import FormItem from "../components/Money/FormItem.vue";
import PressButton from "../components/PressButton.vue";

@Component({ components: { FormItem, PressButton } })
export default class EditLabel extends Vue {
  // computed
  get currentTag() {
    return this.$store.state.currentTag;
  }
  // hooks
  created() {
    this.$store.commit("fetchTagList");
    this.$store.commit("setCurrentTag", this.$route.params.id);
    if (!this.currentTag) {
      this.$router.replace("/404");
    }
  }
  // methods
  update(name: string) {
    if (this.currentTag) {
      if (name.trim()) {
        this.$store.commit("updateTag", { id: this.currentTag.id, name });
      }
    }
  }
  remove() {
    if (this.currentTag) {
      this.$store.commit("removeTag", this.currentTag.id);
      window.alert("已删除！");
      this.goBack();
    } else {
      window.alert("删除失败！");
    }
  }
  goBack() {
    this.$router.back();
  }
}
